import ReactOnRails from "react-on-rails";
import { OutputForm } from "../../components/common/FlowBots/Outputs/OutputForm";
import { AppOutputForm } from "../../components/common/FlowBots/Outputs/AppOutputForm";
import { OperationTitleInput } from "../../components/templates/operations/OperationTitleInput";

ReactOnRails.register({
  OutputForm: OutputForm,
  AppOutputForm: AppOutputForm,
  OperationTitleInput: OperationTitleInput,
});
